<template>
    <div
        class="min-h-screen flex sm:justify-center pt-6 sm:pt-0 overflow-hidden"
    >
        <v-container class="flex justify-center align-center">
            <div :class="[$vuetify.breakpoint.xs ? null : 'upper-third']">
                <div class="flex justify-center">
                    <v-img
                        v-bind:src="'/musicologie-wordmark.webp'"
                        max-width="200"
                        class="mx-4"
                    />
                </div>
                <div class="flex-col">
                    <lottie-player
                        src="https://assets3.lottiefiles.com/packages/lf20_no08B3.json"
                        background="transparent"
                        style="width: inherit; height: 300px"
                        speed="1"
                        loop
                        autoplay
                    ></lottie-player>
                    <v-card-title class="soli-grey justify-center"
                        >Awesome, you’re registered!</v-card-title
                    >
                    <v-card-subtitle
                        class="soli-grey"
                        style="text-align: center; white-space: pre-line"
                        >We’ll send more details as the day gets closer. Contact
                        <a
                            class="soli-blue-text"
                            style="white-space: nowrap"
                            href="mailto:justin@musicologie.com"
                        >
                            justin@musicologie.com
                        </a>
                        with questions.</v-card-subtitle
                    >
                    <SoliBtn
                        class="justify-center w-full"
                        text="Return Home"
                        :href="route('login')"
                        gradient="gradient-blue"
                    ></SoliBtn>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
export default {
    mounted() {
        if (document.querySelector("#lottie")) return;
        let lottie = document.createElement("script");
        lottie.setAttribute(
            "src",
            "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
        );
        lottie.id = "lottie";
        document.head.appendChild(lottie);
        console.log(this.errors);
    },
};
</script>
